import React, {useContext} from "react";
import {useDrop} from "react-dnd";
import {AcceptTypes} from "../../../ToolBar/ToolBarUtils/ItemTypes";
import RenderComponents from "../index";
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";

const TabContainer = ({index, component, path}) => {
    const {
        onDropComponent,
        onMoveComponent,
        onDropMultipleComponents
    } = useContext(ScreenDesignerContextNew);

    const [{isOverCurrent}, drop] = useDrop({
        accept: AcceptTypes.panel,
        collect: monitor => ({
            isOverCurrent: monitor.isOver({shallow: true}),
        }),
        drop: (item, monitor) => {
            let newItem = {...item};
            let currentComponent = item.component ? item.component : {};
            let componentChildrenLength = item.component && item.component.children ? item.component.children.length : 0;

            const didDrop = monitor.didDrop();
            if (didDrop) {
                return
            }

            //checking for children, if not, insert item into new panel
            if (item.children && item.type === 'panel') {
                newItem = {
                    ...newItem, children: [{
                        type: 'panel',
                        styles: [{
                            width: "100%",
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                        }],
                        children: []
                    }]
                }
            }
            if (item.dragType === 'move') {

                //insert panel inside container
                if (item.component.type === 'panel') {
                    currentComponent = {
                        ...item.component, children: [{
                            type: 'panel',
                            styles: [{
                                width: "100%",
                                justifyContent: 'flex-start',
                                flexDirection: 'column',
                                alignItems: 'flex-start'
                            }],
                            children: item.component.children
                        }]
                    };
                }

                onMoveComponent(currentComponent, item.from, `${path}.children.${index}.children`, componentChildrenLength);
                return
            }
            if (item.dragType === 'multiple') {
                onDropMultipleComponents(currentComponent, componentChildrenLength, `${path}.children.${index}.children`);
                return
            }

            onDropComponent(newItem, componentChildrenLength, `${path}.children.${index}.children`)
        }
    });
    return (
        <div ref={drop}
             style={{
                 border: isOverCurrent ? '1px dashed green' : '1px dashed #f7f7f7',
                 height: '99%',
                 display: 'flex',
                 padding: 5,
                 flexDirection: 'column',
                 justifyContent: 'flex-start',
                 alignItems: 'baseline',
                 overflow:'auto'
             }}>
            {(component.children || []).map((item, i) => {
                return (
                    <RenderComponents
                        key={`children.${i}`}
                        item={item}
                        type={item.type}
                        parentPath={`${path}.children.${index}`}
                        index={i}
                        path={`${path}.children.${index}.children.${i}`}
                    />
                )
            })}
        </div>
    )
};
export default TabContainer;